import { Header } from './Header/Header'
import { Settings } from 'lib/sanity.queries'
import { SiteMeta } from './SiteMeta'

export default function SiteLayout({
  preview,
  loading,
  children,
  settings,
}: {
  preview: boolean
  loading?: boolean
  children: React.ReactNode
  settings: Settings
}) {
  return (
    <>
      <SiteMeta {...settings} />
      {settings?.headerMenu && settings?.headerMobileMenu ? (
        <Header
          announcement={settings?.announcement}
          menu={settings.headerMenu}
          mobileMenu={settings.headerMobileMenu}
          logo={settings.logo}
        />
      ) : null}
      <section>{children}</section>
    </>
  )
}
